export class Company {
  id: number;
  name: string;
  vatId: string;
  address: string;
  inVatSystem: boolean;
  businessPremises: BusinessPremise [];

  constructor(data?: any) {
    if (data) {
      Object.assign(this, data);
    }
  }
}

export class BusinessPremiseBasic {
  companyBP: string;
  bpId: number;
  companyId: number;
  mrt: string;

  constructor(data?: any) {
    if (data) {
      Object.assign(this, data);
    }
  }
}



export class BusinessPremise {
  id: number;
  code: string;
  fiscal: boolean;
  haveInvoice: boolean;
  storeTerminals: StoreTerminal [];
  address: string;
  mrt: string;
  saleChannel: SaleChannel;

  constructor(data?: any) {
    if (data) {
      Object.assign(this, data);
    }
  }
}

export class SaleChannel {
  id: number;
  code: string;
  publicName: string;
  isDistributionChannel: boolean;

  constructor(data?: any) {
    if (data) {
      Object.assign(this, data);
    }
  }
}

export class StoreTerminal {
  id: number;
  codeNumber: string;
  channelType: string;


  constructor(data?: any) {
    if (data) {
      Object.assign(this, data);
    }
  }
}

export class BusinessPremisePrices {
  id: number;
  name: string;
  price: number;
  bppriceListCode: number;

  constructor(data?: any) {
    if (data) {
      Object.assign(this, data);
    }
  }
}



// WEBPACK FOOTER //
// ./src/app/shared/model/Company.ts